var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMultipleChoice = function SvgQuestionMultipleChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9a.73.73 0 0 0-.5.22l-2.8 2.79a.73.73 0 1 0 1.03 1.03l2.79-2.8A.73.73 0 0 0 15.89 9zm4.35 0a.73.73 0 0 0-.5.22L13 15.97l-2.4-2.39a.73.73 0 1 0-1.02 1.03l2.9 2.9c.29.29.75.29 1.03 0l7.27-7.26A.73.73 0 0 0 20.25 9M5.73 13.36a.73.73 0 0 0-.51 1.25l2.36 2.36a.73.73 0 1 0 1.03-1.03l-2.36-2.36a.73.73 0 0 0-.52-.22"
  })));
};
export default SvgQuestionMultipleChoice;